<template>
  <div class="flex items-center justify-center gap-28 p-6" data-testid="page-meetings-entry-point">
    <!-- Text content on left -->
    <div class="flex flex-col items-start gap-4">
      <h3 class="text-headline-xl">{{ t('Meetings.enableTitle') }}</h3>
      <p class="max-w-[420px] text-body-s text-subtle">{{ t('Meetings.enableDescription') }}</p>
      <button class="btn-primary-color-s" :disabled="enabling" @click="activateMeetings">
        {{ t('Meetings.enableButton') }}
      </button>
    </div>
    <!-- Illustration on right -->
    <div class="shrink-0">
      <img src="/assets/images/meetings-illustration.svg" alt="" class="h-[349px] w-[266px]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { ROOT_EVENT_SLUG } from '@/components/VisitorProfiles/config'
import { useMeetingsEnableMutation } from '@/gql/myomr'

const { t } = useI18n()

const emit = defineEmits<{
  enabled: []
}>()

const { mutate: meetingsEnableMutation } = useMeetingsEnableMutation()
const enabling = ref(false)

async function activateMeetings() {
  enabling.value = true
  try {
    const result = await meetingsEnableMutation({
      eventSlug: ROOT_EVENT_SLUG,
    })

    const errors = result?.data?.meetingsEnable?.errors || []
    if (errors.length > 0) {
      return
    }
    emit('enabled')
  } finally {
    enabling.value = false
  }
}
</script>
